module.exports = __webpack_public_path__ + "img/img-box-default.0160f1a2.jpg";